import i18n from '../../i18n';
import { env } from '../../utils/env';
import { filters } from './mapFilters';
import { services } from './services';

const t = (key: string) => i18n.t(key) as unknown as string;
const tArray = (key: string) => i18n.t(key) as unknown as string[];

const store = {
  state: {
    page: null,
    service: null,
    city: null,
    age: null,
    robot: null,
    locationId: null,
    occurrence: null,

    tips: {
      mapFilter: true,
    },

    map: {
      center: null,
      zoom: null,
      filters: filters,
    },

    contactForm: {
      name: { text: '', valid: false },
      date: { text: null, valid: false },
      email: { text: '', valid: false },
      phone: { text: '', valid: false },
      address: { text: '', valid: false },
      knownClient: { text: '', valid: false },
      paymentType: { text: '', valid: false },
      postalCode: { text: '', valid: false },
      streetAddress: { text: '', valid: false },
      parentFullName: { text: '', valid: false },
      city: { text: '', valid: false },
      comment: { text: '', valid: true },
      schoolClass: {text: "", valid: true },
      promoCoupon: { text: '', valid: false },
      allergies: {text: '', valid: false},
      specialNeeds: {text: '', valid: false}
    },

    agreements: null,
  },

  data: {
    steps: 5,
    franchises: null,
    workshops: null,
    consents: null,

    logoSrc: `${env.PUBLIC_URL}/assets/images/go4robot.png`,
    mainTitleDescription: {
      title: t('mainTitle.title'),
      description: t('mainTitle.description'),
    },
    mainTitleDescriptionAlt: t('mainTitle.alt'),
    filterMenuText: t('filterMenu.text'),
    generalTiles: [
      {
        type: 1,
        title: 210,
        image: `${process.env.PUBLIC_URL}/assets/icons/szkoly.svg`,
        description: t('generalTiles.schools'),
      },
      {
        type: 1,
        title: t('generalTiles.experienceValue'),
        image: `${process.env.PUBLIC_URL}/assets/icons/lata.svg`,
        description: t('generalTiles.experience'),
      },
      {
        type: 1,
        title: 6000,
        image: `${env.PUBLIC_URL}/assets/icons/zadowolonych.svg`,
        description: t('generalTiles.children'),
      },
    ],
    cityFormLabel: t('labels.city'),
    serviceFormLabel: t('labels.service'),
    services: services,
    formFieldErrors: {
      name: t('formFieldErrors.name'),
      email: t('formFieldErrors.email'),
      phone: t('formFieldErrors.phone'),
      date: t('formFieldErrors.date'),
      dateAgeTooLow: t('formFieldErrors.dateAgeTooLow'),
      paymentType: t('formFieldErrors.paymentType'),
      streetAddress: t('formFieldErrors.streetAddress'),
      postalCode: t('formFieldErrors.postalCode'),
      city: t('formFieldErrors.city'),
    },
    formPageSingle: {
      locationLabel: t('formPageSingle.locationLabel'),
      mainLabel: t('formPageSingle.mainLabel'),
    },
    formPage: {
      mainLabel: t('formPage.mainLabel'),
      offerText: t('formPage.offerText'),
      nameLabel: t('formPage.nameLabel'),
      nameHint: t('formPage.nameHint'),
      datapickerLabel: t('formPage.datapickerLabel'),
      datapickerHint: t('formPage.datapickerHint'),
      weekDaysLabel: t('formPage.weekDaysLabel'),
      emailLabel: t('formPage.emailLabel'),
      emailHint: t('formPage.emailHint'),
      phoneLabel: t('formPage.phoneLabel'),
      phoneHint: t('formPage.phoneHint'),
      allergyHint: t('formPage.allergyHint'),
      specialNeedsHint: t('formPage.specialNeedsHint'),
      knownClientLabel: t('formPage.knownClientLabel'),
      knownClientHint: t('formPage.knownClientHint'),
      schoolClassLabel: t('formPage.schoolClassLabel'),
      commentLabel: t('formPage.commentLabel'),
      errorInfo: t('formPage.errorInfo'),
      whyData: t('formPage.whyData'),
    },
    servicePage: {
      placeholder: t('servicePage.placeholder'),
    },
    agePage: {
      placeholder: t('agePage.placeholder'),
    },
    cityPage: {
      placeholder: t('cityPage.placeholder'),
    },
    mapPage: {
      suggestion: t('mapPage.suggestion'),
      PERIODIC: t('mapPage.PERIODIC'),
      DEMO: t('mapPage.DEMO'),
      dayText: t('mapPage.dayText'),
      locationPlaceholder: t('mapPage.locationPlaceholder'),
      locationHeader: t('mapPage.locationHeader'),
      levelHeader: t('mapPage.levelHeader'),
    },
    singleInputPage: {
      descriptions: tArray('singleInputPage.descriptions'),
    },
    robotAccordion: {
      description1: t('robotAccordion.description1'),
      description2: t('robotAccordion.description2'),
      description3: t('robotAccordion.description3'),
      secondary: t('robotAccordion.secondary'),
      primary: t('robotAccordion.primary'),
    },
    selectOptionInfo: {
      description1: t('selectOptionInfo.description1'),
      description2: t('selectOptionInfo.description2'),
      title: t('selectOptionInfo.title'),
      secondary: t('selectOptionInfo.secondary'),
      primary: t('selectOptionInfo.primary'),
    },
    mapMarkers: {
      standard: `${env.PUBLIC_URL}/assets/icons/map.svg`, // unused
      selected: `${env.PUBLIC_URL}/assets/icons/map-s.svg`, //unused
    },
    newIcons: {
      coinFree: `${env.PUBLIC_URL}/assets/icons/coins_free.svg`,
      coinZl: `${env.PUBLIC_URL}/assets/icons/coin_zl.svg`,
      school: `${env.PUBLIC_URL}/assets/icons/szkoly.svg`,
      robot: `${env.PUBLIC_URL}/assets/icons/lata.svg`,
      hours: `${env.PUBLIC_URL}/assets/icons/hours.svg`,
    },
    selectOptionMap: {
      placeholder: t('selectOptionMap.placeholder'),
      descriptions: tArray('selectOptionMap.descriptions'),
      defaults: tArray('selectOptionMap.defaults'),
      errorInfo: t('selectOptionMap.errorInfo'),
      title: t('selectOptionMap.title'),
      warning: t('selectOptionMap.warning'),
      onlyInternalSignups: t('selectOptionMap.onlyInternalSignups'),
    },
    // TODO use those texts instead of hardcoding
    mapLegend: {
      allChildren: t('mapLegend.allChildren'),
      onlyLocalChildren: t('mapLegend.onlyLocalChildren'),
    },
    sendText: t('common.send'),
    nextText: t('common.next'),
    chooseText: t('common.choose'),
    serviceErrorMessage: t('errors.service'),
    levelErrorMessage: t('errors.level'),
    noWorkshopErrorMessage: t('errors.noWorkshop'),
    noSummerplayErrorMessage: t('errors.noSummerplay'),
    robotFormLabel: t('labels.robot'),
    ageFormLabel: t('labels.age'),

    thankYou: t('thankYou.heading'),
    thankYouTitle: t('thankYou.title'),
    thankYouDescriptionF: t('thankYou.descriptionFirst'),
    thankYouDescriptionS: t('thankYou.descriptionSecond'),
    workshopsCurrentLocation: null,
    paymentOptions: [
      {
        key: 1,
        value: 'kindergarden_vat_invoice',
        text: t('paymentOptions.kindergarden_vat_invoice'),
      },
      { key: 2, value: 'parent_monthly', text: t('paymentOptions.parent_monthly') },
      { key: 3, value: 'parent_by_semester', text: t('paymentOptions.parent_by_semester') },
      { key: 4, value: 'payment_yearly', text: t('paymentOptions.payment_yearly') },
    ],
  },
};

export default store;
